// extracted by mini-css-extract-plugin
export default {"divider":"h2UC9xKP"};